import { Theme } from '@src/types/enum.js';

export type TemplateTheme = Theme.OCCL | Theme.TEFONE;

let resolverInstance: TemplateResolver<unknown> | null;

export class TemplateResolver<TemplatesDefinition> {
  private theme: TemplateTheme;
  private templates: TemplatesDefinition;

  private constructor(theme: TemplateTheme, templates: TemplatesDefinition) {
    this.theme = theme;
    this.templates = templates;
  }

  // eslint-disable-next-line @typescript-eslint/ban-types -- "Return type is dynamic based on code in function. How to do that?"
  resolve<TN extends keyof typeof this.templates[keyof typeof this.templates]>(templateName: TN): Function {
    const themedTemplates = this.templates[this.theme as keyof TemplatesDefinition];

    if (!themedTemplates) {
      throw new Error(`Could not find template theme '${this.theme}'. Did you pass the correct structure to TemplatingMixin()?`);
    }

    const template = themedTemplates[templateName];
    if (!template) {
      throw new Error(`Could not find template '${String(templateName)}' for theme '${this.theme}'. File missing in 'src/components/templates/${this.theme}/${String(templateName)}.tmpl.ts' ?`);
    }

    // How to type the function that is returned from the template without having them  (FS, 02.08.2024)
    // as typeof this.templates[this.theme][templateName];
    return template as unknown as Function; // eslint-disable-line
  }

  static getInstance<TemplatesDefinition>(theme: TemplateTheme, templates: TemplatesDefinition) {
    if (!resolverInstance) {
      resolverInstance = new TemplateResolver<typeof templates>(theme, templates);
    }
    return resolverInstance;
  }

  static clear() {
    resolverInstance = null;
  }
}
